import {
  Box,
  Button,
  Divider,
  GColorsTag,
  GProductShare,
  VStack,
} from '@gazin/ecommerce-ui'
import { useState } from 'react'
import { Favorito } from 'src/contexto/types'
import ProductContentFavoriteButton from './../favoriteButton'
import { Gallery } from './gallery'
import { FavoriteProductMethod } from 'src/components/conteudoFavoritos/types'
import { ModalShare } from './modalShare'

type Image = {
  url: string
}

interface ProductImageSliderProps {
  activeProductVariation: { imagens: Image[] }
  favoriteProduct: FavoriteProductMethod
  favoritesStore: Favorito[]
  numberOfUniqueColors: number
  productId: number
  productTitle: string
  productUrl: string
  URLShare: string
  productColor?: string
  productVoltage?: string
}

export const ProductImageSlider = ({
  activeProductVariation,
  favoriteProduct,
  favoritesStore,
  numberOfUniqueColors,
  productId,
  productTitle,
  productUrl,
  URLShare,
  productColor,
  productVoltage,
}: ProductImageSliderProps) => {
  const [showShare, setShowShare] = useState(false)

  const shareUrl = () => {
    if (navigator.share) {
      return navigator.share({
        url: URLShare,
        title: productTitle,
      })
    }

    return setShowShare(true)
  }

  return (
    <Box
      data-testid="product-image-slider"
      mb={{ base: '1rem', lg: '0' }}
      mr={{ base: '0' }}
      w={{ base: '100%', lg: 'fit-content' }}
    >
      <Box
        h={{ base: 'fit-content' }}
        position="relative"
        w={{ base: '100%', lg: '27.553rem' }}
      >
        {numberOfUniqueColors > 1 && (
          <Box
            css={`
              > div > span > p:first-of-type {
                margin-bottom: 0;
              }
            `}
            data-testid="colors-tag"
            left="1rem"
            position="absolute"
            top={['0', '1rem']}
            zIndex={2}
          >
            <GColorsTag colorsQuantity={numberOfUniqueColors} />
          </Box>
        )}

        <Gallery
          images={
            activeProductVariation.imagens.length
              ? activeProductVariation.imagens
              : [
                  {
                    url: `${process.env.INTERNAL_IMAGES_URL}/images/jpg/produto-default.jpg`,
                  },
                ]
          }
        />

        <VStack
          alignItems="flex-end"
          position="absolute"
          right="1rem"
          top={['0', '1rem']}
          zIndex={2}
        >
          {productColor && productVoltage && (
            <ProductContentFavoriteButton
              color={productColor}
              favoriteProduct={favoriteProduct}
              favoritesStore={favoritesStore}
              product_id={productId}
              product_url={productUrl}
              voltage={productVoltage}
            />
          )}

          <Button
            _hover={{ bg: 'transparent' }}
            bg="transparent"
            data-testid="share-button"
            justifyContent="flex-end"
            onClick={shareUrl}
            onMouseLeave={() => setShowShare(false)}
            p={{ base: 0 }}
          >
            <GProductShare color="#A0A4B3" h={6} mt="0.25rem" w={6} />
            <ModalShare URLShare={URLShare} showShare={showShare} />
          </Button>
        </VStack>
      </Box>
      <Divider bg="#E3E3E8" display={{ lg: 'none' }} h="2px" w="100%" />
    </Box>
  )
}
